import React from "react";

export default function Header() {
  return (
    <div className="header">

      <div className="header-left">
        <h2>શ્રી ધનલક્ષ્મી મહિલા કો-ઓપ. ક્રેડિટ સોસાયટી</h2>
      </div>
      <div className="header-right"> 
        <div className="profile">
          <img src="/images/1.png" alt="admin" />
          <span>Admin</span>
        </div>
      </div>

    </div>
  );
}